export default [
  { id: 1, name: 'Администрация Губернатора' },
  { id: 2, name: 'Мособлконтроль' },
  { id: 3, name: 'Главгосстройнадзор МО' },
  { id: 4, name: 'Гражданская защита' },
  { id: 5, name: 'Культурное наследие' },
  { id: 6, name: 'Мировые судьи' },
  { id: 7, name: 'ГУРБ МО' },
  { id: 8, name: 'Мособлкомлес' },
  { id: 9, name: 'Мособлархитектура' },
  { id: 10, name: 'Мособлконкуренция' },
  { id: 11, name: 'Комитет по ценам и тарифам МО' },
  { id: 12, name: 'Минблаго' },
  { id: 13, name: 'Мингосуправления МО' },
  { id: 14, name: 'МинЖКХ' },
  { id: 15, name: 'Минжилполитики' },
  { id: 16, name: 'Минздрав МО' },
  { id: 17, name: 'Минимущество' },
  { id: 18, name: 'Мининвест МО' },
  { id: 19, name: 'МИМП МО' },
  { id: 20, name: 'Минкульт МО' },
  { id: 21, name: 'Минобр МО' },
  { id: 22, name: 'Минчистоты МО' },
  { id: 23, name: 'Минсельхозпрод МО' },
  { id: 24, name: 'Минсоц МО' },
  { id: 25, name: 'Минстрой МО' },
  { id: 26, name: 'Минтер МО' },
  { id: 27, name: 'МТДИ МО' },
  { id: 28, name: 'Минспорт МО' },
  { id: 29, name: 'Минэкологии МО' },
  { id: 30, name: 'МЭФ МО' },
  { id: 31, name: 'Минэнерго МО' },
  { id: 32, name: 'Управление делами Губернатора МО' },
  { id: 33, name: 'Техническая команда' },
];
